import React, {
    FunctionComponent,
    useEffect,
    useState,
    useRef,
} from "react";
import styles from "./Integrations.module.css";
import Modal from "react-modal";
import { IoIosClose } from "react-icons/io";

import DropdownWithValue from "../DropDown/DropdownWithValue";

import Loading from "../Loading/Loading";
import { connect, useDispatch } from "react-redux";
import { showSnackbarAction } from "../../Redux/actions";
import { useHistory, useLocation } from "react-router-dom";
import TextInput from "../TextInput/TextInput";
import { marginTop, themeColors } from "../theme";
import Label from "../Label";
import { motion } from "framer-motion";
import Backdrop from "../Backdrop/Backdrop";
import FacebookLogin from '@greatsumini/react-facebook-login';
import axios from 'axios';
import NewButton from "../NewComponents/NewButton/NewButton";
import { Box } from "@material-ui/core";
import { getFBForms,getFBPages,createFBIntegration,createGoogleSheetIntegration } from "../../Services/fbIntegration";
import IntegrationVerification from "../NewComponents/IntegrationVerification/IntegrationVerification";
import { googleAnalyticsCTAClick } from "../../Services/users";
type props = {
    close: () => void;
    open: boolean;
    user: any;
    authToken: any;
    theme: any;
};

const dropIn = {
    hidden: {
        y: "-100vh",
        opacity: 1,
    },
    visible: {
        y: "0",
        opacity: 1,
        transition: {
            duration: 1,
            type: "spring",
            damping: 25,
            stiffness: 500,
        },
    },
};

const appId = '310905785444511';

const IntegrationForm: FunctionComponent<props> = ({
    close,
    open,
    user,
    authToken,
    theme
}) => {
    const [load, setLoad] = useState(false);
    const integrationNameRef: any = useRef();
    const googleSheetUrlRef: any = useRef();
    const googleSheetIdRef: any = useRef();
    const googleSheetNameRef: any = useRef();
    const googleSheetTimeIntervalRef: any = useRef();
    const [accessToken, setAccessToken] = useState("");
    const [sheetId, setSheetId] = useState("");
    const [sheetUrl, setSheetUrl] = useState("");
    const [integrationTypeSelected, setIintegrationTypeSelected] =
        useState<any>({
            label: "Select",
            value: "Select",
        });
        const [timeIntervalSelected, setTimeIntervalSelected] =
        useState<any>({
            label: "Select",
            value: "Select",
        });
    const [fbPageSelected, setFBPageSelected] =
        useState<any>({
            label: "Select",
            value: "Select",
        });
    const [fbFormSelected, setFBFormSelected] =
        useState<any>({
            label: "Select",
            value: "Select",
        });
    const [integrationTypeList, setIntegrationTypeList] = useState<
        Object[]
    >([
        // { label: "FB LEADS", value: "FB LEADS" }, 
        { label: "GOOGLE SHEET", value: "GOOGLE SHEET" }]);
        const [integrationTypeListDemo, setIntegrationTypeListDemo] = useState<
        Object[]
    >([
        { label: "FB LEADS", value: "FB LEADS" }, 
        { label: "GOOGLE SHEET", value: "GOOGLE SHEET" }]);
        const [timeInterval, setTimeInterval] = useState<
        Object[]
    >([
        { label: "5 min", value: "5" }, 
        { label: "10 min", value: "10" }, 
        { label: "15 min", value: "15" }, 
        { label: "30 min", value: "30" }, 
        { label: "60 min", value: "60" }]);
    const [fbPagesList, setFbPagesList] = useState<
        Object[]
    >([]);
    const [fbFormsList, setFbFormsList] = useState<
        Object[]
    >([]);
    const [fbPagesData, setFbPagesData] = useState<
        Object[]
    >([]);

    const [showGiveAcess, setShowGiveAcess] = useState(false);
    const [reload, setReload] = useState(false);
    const dispatcher = useDispatch();
    const history = useHistory();
    const location: any = useLocation();

    const customStyles = {
        content: {
            backgroundColor: theme ? themeColors.dropdownBackgroundColor : themeColors.dropdownBackgroundColorDark, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark
        },
    };
    const containerStyles = { backgroundColor: theme ? themeColors.backgroundColor : themeColors.backgroundColorDark, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark, maxHeight: "400px" };

    useEffect(() => {
        const extractSheetId = (url: any) => {
            if (typeof url === 'string') {
                const regex = /\/d\/([a-zA-Z0-9-_]+)/;
                const matches = url.match(regex);
                return matches ? matches[1] : null;
            }
            return null;
        };

        // Extract the sheetId and set it in the state
        const id = extractSheetId(googleSheetUrlRef?.current?.value);
        if (id) {
            setSheetId(id);
        }
    }, [googleSheetUrlRef?.current?.value]);

    useEffect(() => {
        if (googleSheetIdRef.current) {
            googleSheetIdRef.current.value = sheetId;
        }
    }, [sheetId]);
    // console.log("user.organization_id11111111111111",user.organization_id)
    return (
        <>
            {load === true && <Loading />}
            {open && <Backdrop>
                <motion.div
                    key="modal"
                    className="card p-4 shadow rounded"
                    style={{
                        position: "absolute", minWidth: "400px",
                        ...containerStyles
                    }}
                    variants={dropIn}
                    initial="hidden"
                    animate="visible"
                    exit="exit"
                >
                    <div className={styles.firstDiv}>
                        <h5
                        // className={styles.contactForm}
                        >
                            Add Integration
                        </h5>
                        <div className={styles.cross} onClick={close}>
                            <IoIosClose size={35} color={"#808080"} />
                        </div>
                    </div>
                    <div className={styles.line}></div>

                    <div style={{ overflowY: "auto" }}>
                        <div className={styles.box2}>
                            <div
                                className={styles.divide}
                                style={{ width: "100%" }}
                            >
                                <Label label="Integration Type" required={true} />
                                <div style={{ marginTop: "7px" }}>
                                    <DropdownWithValue
                                        // option={(user.organization_id == "W5phvDYBAtopkrdehko2" || user.organization_id == "dAZC04j9Ex8ieHlh85eh") ? integrationTypeListDemo : integrationTypeList}
                                        option={integrationTypeListDemo}
                                        selectedValue={integrationTypeSelected}
                                        setSelectedValue={(value) => {
                                            setIintegrationTypeSelected(value);
                                        }}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className={styles.box2}>
                            <div
                                className={styles.divide}
                                style={{ width: "100%" }}
                            >
                                <Label label="Integration Name" required={true} />
                                <div>
                                    <TextInput
                                        title={"Enter name"}
                                        style={{ backgroundColor: "#fff" }}
                                        ref={integrationNameRef}
                                    ></TextInput>
                                </div>
                            </div>
                        </div>

                        {
                            integrationTypeSelected.value === "FB LEADS" ? <>

                                <div className={styles.box2}>
                                    <div
                                        className={styles.divide}
                                        style={{ width: "100%" }}
                                    >
                                        <FacebookLogin
                                            appId={appId}
                                            initParams={{
                                                version: 'v10.0',
                                            }}
                    
                                            // pages_read_engagement,pages_manage_metadata,ads_management,pages_manage_ads,pages_show_list,
                                            scope='leads_retrieval,pages_manage_ads,pages_show_list,pages_read_engagement'
                                            style={{
                                                backgroundColor: '#4267b2',
                                                color: '#fff',
                                                // fontSize: '16px',
                                                padding: '0.5rem',
                                                border: 'none',
                                                borderRadius: '0.25rem',
                                                // width:"100px"
                                                // height: "100px"
                                            }}
                                            onSuccess={(response) => {
                                                // console.log('FB Login Success!', response);
                                                setAccessToken(response.accessToken);
                                                getFBPages(response.userID, response.accessToken,setFbPagesList,setFbPagesData);
                                            }}
                                            onFail={(error) => {
                                                console.log('FB Login Failed!', error);
                                            }}
                                            onProfileSuccess={(response) => {
                                                // console.log('FB Get Profile Success!', response);
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className={styles.box2}>
                                    <div
                                        className={styles.divide}
                                        style={{ width: "100%" }}
                                    >
                                        <Label label="Select Page ( For Fetching Forms )" required={true} />
                                        <div style={{ marginTop: "7px" }}>
                                            <DropdownWithValue
                                                option={fbPagesList}
                                                selectedValue={fbPageSelected}
                                                setSelectedValue={(value) => {
                                                    setFBPageSelected(value);
                                                    getFBForms(value.value,fbPagesData,setFbFormsList);
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className={styles.box2}>
                                    <div
                                        className={styles.divide}
                                        style={{ width: "100%" }}
                                    >
                                        <Label label="Select Form ( For Fetching Leads )" required={true} />
                                        <div style={{ marginTop: "7px" }}>
                                            <DropdownWithValue
                                                option={fbFormsList}
                                                selectedValue={fbFormSelected}
                                                setSelectedValue={(value) => {
                                                    setFBFormSelected(value);
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </> : null
                        }

                        {
                            integrationTypeSelected.value === "GOOGLE SHEET" ?
                                <>
                                    <div className={styles.box2}>
                                        <div
                                            className={styles.divide}
                                            style={{ width: "100%" }}
                                        >
                                            <Label label="Google Sheet Url" required={true} />
                                            <div>
                                                <TextInput
                                                    title={"Enter Google Sheet Url"}
                                                    style={{ backgroundColor: "#fff" }}
                                                    ref={googleSheetUrlRef}
                                                    onChange={() => setSheetUrl(googleSheetUrlRef?.current?.value)}
                                                ></TextInput>
                                            </div>
                                        </div>
                                    </div>

                                    {/* <div className={styles.box2}>
                                        <div
                                            className={styles.divide}
                                            style={{ width: "100%" }}
                                        >
                                            <Label label="Google Sheet Id" required={true} />
                                            <div>
                                                <TextInput
                                                    title={"Google Sheet Id"}
                                                    style={{ backgroundColor: "#fff" }}
                                                    ref={googleSheetIdRef}
                                                    value={sheetId} // set the value to the state variable
                                                    disabled
                                                ></TextInput>
                                            </div>
                                        </div>
                                    </div> */}

                                    <div className={styles.box2}>
                                        <div
                                            className={styles.divide}
                                            style={{ width: "100%" }}
                                        >
                                            <Label label="Enter Google Sheet Name" required={true} />
                                            <div>
                                                <TextInput
                                                    title={"Sheet Name"}
                                                    style={{ backgroundColor: "#fff" }}
                                                    ref={googleSheetNameRef}
                                                ></TextInput>
                                            </div>
                                        </div>
                                    </div>

                                    <div className={styles.box2}>
                                        <div
                                            className={styles.divide}
                                            style={{ width: "100%" }}
                                        >
                                            <Label label="Interval To Fetch Data" required={true} />
                                            {/* <div>
                                                <TextInput
                                                    title={"Time Interval ( In Minutes )"}
                                                    style={{ backgroundColor: "#fff" }}
                                                    ref={googleSheetTimeIntervalRef}
                                                ></TextInput>
                                            </div> */}
                                            <div style={{ marginTop: "7px" }}>
                                    <DropdownWithValue
                                        option={timeInterval}
                                        selectedValue={timeIntervalSelected}
                                        setSelectedValue={(value) => {
                                            setTimeIntervalSelected(value);
                                        }}
                                        direction="top"
                                    />
                                </div>
                                        </div>
                                    </div>
                                </> : null
                        }
                    </div>

                    {/* <button
                        className={styles.apply}
                        style={{ marginTop: "1rem" }}
                        onClick={onSubmit}
                    >
                        Save
                    </button> */}
                    <NewButton title="Save" 
                    onClick={()=>{
                        if(integrationTypeSelected.value === "FB LEADS"){
                            googleAnalyticsCTAClick("Save FaceBook Sheet Integration","Integration Screen",user)
                        }
                        else{
                            googleAnalyticsCTAClick("Save Google Sheet Integration","Integration Screen",user)
                        }
                        integrationTypeSelected.value === "FB LEADS" ?
                        createFBIntegration(
                            fbPageSelected,
                            fbPagesData,
                            user.organization_id,
                            integrationTypeSelected.value,
                            integrationNameRef.current.value,
                            "INACTIVE",
                            {},
                            user.uid,
                            user.uid,
                            fbPageSelected.label,
                            fbFormSelected.label,
                            dispatcher,
                            setLoad,
                            history,
                            authToken,
                            fbFormSelected.value,
                            accessToken,
                            fbPageSelected.value,
                        ):
                        
                        createGoogleSheetIntegration(
                            user.organization_id,
                            integrationTypeSelected.value,
                            integrationNameRef.current.value,
                            "INACTIVE",
                            {},
                            googleSheetUrlRef.current.value,
                            googleSheetNameRef.current.value,
                            sheetId,
                            timeIntervalSelected.value,
                            user.uid,
                            user.uid,
                            dispatcher,
                            setLoad,
                            setReload,
                            history,
                            authToken,
                        )
                        setShowGiveAcess(true)
                    }}
                    style={{marginTop:"1rem"}}
                    />
                </motion.div>
            </Backdrop>}
            {integrationTypeSelected.value === "GOOGLE SHEET" &&
            <IntegrationVerification
                title="Google Sheet Access"
                description="Please provide Access to the given Id"
                Id="readpro-gsheet@read-pro.iam.gserviceaccount.com"
                open={showGiveAcess}
                setOpen={setShowGiveAcess}
                reload={reload}
            />}
        </>
    );
};

const mapStateToProps = (state: any) => {
    return {
        user: state.user.data,
        theme: state.theme.isLightMode,
        authToken: state.user.authToken,
    };
};

export default connect(mapStateToProps)(IntegrationForm);
